module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "90px"
    }
  }, [_c('el-form', {
    ref: "ecxForm",
    attrs: {
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "50px"
    },
    attrs: {
      "label": "选择皮肤",
      "prop": "appType"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "15%"
    },
    attrs: {
      "disabled": false,
      "placeholder": "选择皮肤"
    },
    model: {
      value: (_vm.skinValue),
      callback: function($$v) {
        _vm.skinValue = $$v
      },
      expression: "skinValue"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "0",
      "label": "默认皮肤"
    }
  }, [_vm._v("默认皮肤")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "1",
      "label": "端午节皮肤"
    }
  }, [_vm._v("端午节皮肤")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "80px",
      "width": "200px",
      "margin-top": "-70px",
      "margin-left": "315px"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.modelImgUrl
    }
  })])], 1)], 1)], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addPrize()
      }
    }
  }, [_vm._v("\n        +添加奖品\n    ")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "height": "250"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "act_name",
      "label": "等级"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "act_name",
      "label": "名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "act_name",
      "label": "类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "act_name",
      "label": "数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "act_name",
      "label": "概率"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "350"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "text"
          }
        }, [_vm._v("\n                    编辑\n                ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "text"
          }
        }, [_vm._v("\n                    删除\n                ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "font-style": "revert"
    },
    attrs: {
      "title": "奖项设置",
      "visible": _vm.dialogFormVisible,
      "modal-append-to-body": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      },
      "close": function($event) {
        _vm.closeDialog()
      }
    }
  }, [_c('div', {
    staticStyle: {
      "height": "1px",
      "background-color": "#adadad",
      "margin-top": "-30px"
    }
  }), _vm._v(" "), _c('el-form', {
    ref: "ecxForm",
    staticClass: "demo-ruleForm",
    staticStyle: {
      "height": "530px"
    },
    attrs: {
      "model": _vm.ecxForm,
      "rules": _vm.actrules,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "奖品等级",
      "prop": "prizeLevel"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择奖品等级"
    },
    on: {
      "change": function($event) {
        _vm.changePrizeLevel()
      }
    },
    model: {
      value: (_vm.ecxForm.prizeLevel),
      callback: function($$v) {
        _vm.$set(_vm.ecxForm, "prizeLevel", $$v)
      },
      expression: "ecxForm.prizeLevel"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "0",
      "label": "一等奖"
    }
  }, [_vm._v("一等奖")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "1",
      "label": "二等奖"
    }
  }, [_vm._v("二等奖")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "3",
      "label": "三等奖"
    }
  }, [_vm._v("三等奖")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "4",
      "label": "四等奖"
    }
  }, [_vm._v("四等奖")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "5",
      "label": "五等奖"
    }
  }, [_vm._v("五等奖")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "6",
      "label": "六等奖"
    }
  }, [_vm._v("六等奖")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "7",
      "label": "七等奖"
    }
  }, [_vm._v("七等奖")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "8",
      "label": "谢谢参与"
    }
  }, [_vm._v("谢谢参与")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "label": "奖品名称",
      "prop": "prizeName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "placeholder": "奖品名称",
      "disabled": _vm.isCheckStatus
    },
    model: {
      value: (_vm.ecxForm.prizeName),
      callback: function($$v) {
        _vm.$set(_vm.ecxForm, "prizeName", $$v)
      },
      expression: "ecxForm.prizeName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "20px",
      "width": "100%"
    },
    attrs: {
      "label": "奖品类型",
      "prop": "prizeType"
    }
  }, [_c('el-radio-group', {
    staticStyle: {
      "width": "100%"
    },
    on: {
      "change": function($event) {
        _vm.radioStatus()
      }
    },
    model: {
      value: (_vm.ecxForm.prizeType),
      callback: function($$v) {
        _vm.$set(_vm.ecxForm, "prizeType", $$v)
      },
      expression: "ecxForm.prizeType"
    }
  }, [_c('el-radio', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "label": "0",
      "value": "0"
    }
  }, [_vm._v("优惠券")]), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCouponCode),
      expression: "isCouponCode"
    }],
    staticStyle: {
      "margin-left": "70px"
    },
    attrs: {
      "placeholder": "请选择奖品等级"
    },
    on: {
      "change": function($event) {
        _vm.changeCouponCode()
      }
    },
    model: {
      value: (_vm.ecxForm.couponCode),
      callback: function($$v) {
        _vm.$set(_vm.ecxForm, "couponCode", $$v)
      },
      expression: "ecxForm.couponCode"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "0",
      "label": "一等奖"
    }
  }, [_vm._v("一等奖")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "1",
      "label": "二等奖"
    }
  }, [_vm._v("二等奖")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "3",
      "label": "三等奖"
    }
  }, [_vm._v("三等奖")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "4",
      "label": "四等奖"
    }
  }, [_vm._v("四等奖")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "5",
      "label": "五等奖"
    }
  }, [_vm._v("五等奖")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "6",
      "label": "六等奖"
    }
  }, [_vm._v("六等奖")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "7",
      "label": "七等奖"
    }
  }, [_vm._v("七等奖")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "8",
      "label": "谢谢参与"
    }
  }, [_vm._v("谢谢参与")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-radio', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "label": "1",
      "value": "1"
    }
  }, [_vm._v("提货码活动")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDcCode),
      expression: "isDcCode"
    }],
    staticStyle: {
      "width": "33%",
      "margin-left": "40px"
    },
    attrs: {
      "placeholder": "请输入提货码活动Id"
    },
    model: {
      value: (_vm.ecxForm.DcCode),
      callback: function($$v) {
        _vm.$set(_vm.ecxForm, "DcCode", $$v)
      },
      expression: "ecxForm.DcCode"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-radio', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "label": "2",
      "value": "2"
    }
  }, [_vm._v("积分")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isIntegral),
      expression: "isIntegral"
    }],
    staticStyle: {
      "width": "33%",
      "margin-left": "85px"
    },
    attrs: {
      "placeholder": "请输入积分"
    },
    model: {
      value: (_vm.ecxForm.integral),
      callback: function($$v) {
        _vm.$set(_vm.ecxForm, "integral", $$v)
      },
      expression: "ecxForm.integral"
    }
  }), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isIntegralShow),
      expression: "isIntegralShow"
    }],
    staticStyle: {
      "margin-left": "10px",
      "color": "black"
    },
    attrs: {
      "type": "text",
      "disabled": false
    },
    domProps: {
      "textContent": _vm._s(_vm.ecxForm.textIntegral)
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "label": "奖品数量",
      "prop": "prizeName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "placeholder": "奖品数量"
    },
    model: {
      value: (_vm.ecxForm.prizeName),
      callback: function($$v) {
        _vm.$set(_vm.ecxForm, "prizeName", $$v)
      },
      expression: "ecxForm.prizeName"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px",
      "color": "black"
    },
    attrs: {
      "type": "text",
      "disabled": true
    }
  }, [_vm._v("\n                    份\n                ")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "label": "奖品概率",
      "prop": "prizeName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "placeholder": "奖品概率"
    },
    model: {
      value: (_vm.ecxForm.prizeName),
      callback: function($$v) {
        _vm.$set(_vm.ecxForm, "prizeName", $$v)
      },
      expression: "ecxForm.prizeName"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px",
      "color": "black"
    },
    attrs: {
      "type": "text",
      "disabled": true
    }
  }, [_vm._v("\n                    %\n                ")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "float": "right",
      "margin-top": "100px",
      "margin-right": "100px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "id": "save"
    },
    on: {
      "click": function($event) {
        _vm.submitForm('ecxForm')
      }
    }
  }, [_vm._v("保存\n                ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "id": "cancel"
    },
    on: {
      "click": function($event) {
        _vm.closeDialog()
      }
    }
  }, [_vm._v("取消\n                ")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "2%",
      "margin-left": "26.5%"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "id": "last_step"
    },
    on: {
      "click": function($event) {
        _vm.lastStep('ecxForm')
      }
    }
  }, [_vm._v("上一步\n        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "id": "next_step"
    },
    on: {
      "click": function($event) {
        _vm.nextStep('ecxForm')
      }
    }
  }, [_vm._v("下一步\n        ")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "88%",
      "height": "40px",
      "line-height": "40px"
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "#adadad",
      "width": "150px",
      "height": "40px",
      "text-align": "center",
      "vertical-align": "middle",
      "float": "left"
    }
  }, [_vm._v("\n            大转盘皮肤\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#adadad",
      "margin-left": "2px",
      "width": "35%",
      "height": "40px",
      "text-align": "center",
      "color": "#adadad",
      "float": "left"
    }
  }, [_vm._v("\n            大转盘皮肤\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "88%",
      "height": "40px",
      "line-height": "40px"
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "#adadad",
      "width": "150px",
      "height": "40px",
      "text-align": "center",
      "vertical-align": "middle",
      "float": "left"
    }
  }, [_vm._v("\n            中奖奖项设置\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#adadad",
      "margin-left": "2px",
      "width": "35%",
      "height": "40px",
      "text-align": "center",
      "color": "#adadad",
      "float": "left"
    }
  }, [_vm._v("\n            中奖奖项设置\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-90cc6154!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/activity/WheelFragment.vue
// module id = 1087
// module chunks = 2